(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function onLaunch() {
    var section = document.querySelector('.ck-preview-countdown-section');
    if (section) section.style.display = 'none';
    var block = document.querySelector('.product-block--ck-preview-countdown');
    if (block) block.style.display = 'none';

    // product-form approach: re-enable button and restore ATC label
    document.querySelectorAll('[data-ck-preview-btn]').forEach(function (btn) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('data-ck-buy-locked');
      var span = btn.querySelector('[data-add-to-cart-text]');
      var text = btn.getAttribute('data-preview-atc-text');
      if (span && text) span.textContent = text;
    });

    // flex-pdp approach: hide sold-out div, reveal ATC div
    document.querySelectorAll('[data-ck-preview-sold-out]').forEach(function (el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('[data-ck-preview-atc]').forEach(function (el) {
      el.style.removeProperty('display');
    });

    // hide notify me buttons
    document.querySelectorAll('.ck-preview-notify').forEach(function (btn) {
      btn.style.display = 'none';
    });
  }

  document.querySelectorAll('.ck-preview-countdown__timer[data-launch]').forEach(function (timer) {
    var launchMs = parseInt(timer.getAttribute('data-launch'), 10);
    var daysEl = timer.querySelector('[data-days]');
    var hoursEl = timer.querySelector('[data-hours]');
    var minsEl = timer.querySelector('[data-mins]');
    var secsEl = timer.querySelector('[data-secs]');
    var daysUnit = timer.querySelector('[data-days-unit]');
    var daysSep = timer.querySelector('[data-days-sep]');
    var hoursUnit = timer.querySelector('[data-hours-unit]');
    var hoursSep = timer.querySelector('[data-hours-sep]');

    function setVisible(el, visible) {
      if (el) el.style.display = visible ? '' : 'none';
    }

    function tick() {
      var remaining = launchMs - Date.now();

      if (remaining <= 0) {
        clearInterval(interval);
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        setVisible(daysUnit, false);
        setVisible(daysSep, false);
        setVisible(hoursUnit, false);
        setVisible(hoursSep, false);
        setTimeout(onLaunch, 500);
        return;
      }

      var totalSecs = Math.floor(remaining / 1000);
      var d = Math.floor(totalSecs / 86400);
      var h = Math.floor((totalSecs % 86400) / 3600);
      var m = Math.floor((totalSecs % 3600) / 60);
      var s = totalSecs % 60;

      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);

      var showDays = d > 0;
      var showHours = d > 0 || h > 0;
      setVisible(daysUnit, showDays);
      setVisible(daysSep, showDays);
      setVisible(hoursUnit, showHours);
      setVisible(hoursSep, showHours);
    }

    tick();
    var interval = setInterval(tick, 1000);
  });
})();
